import { createRouter, createWebHistory } from 'vue-router'
import ViewTotal from '@/views/ViewTotal.vue'

const routes = [
  {
    // 登录
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    children: []
  },
  {
    path: '/',
    name: 'home',
    component: ViewTotal,
    children: [{
      path: '/realtime',
      name: '态势与控制',
      component: () => import('@/views/realtime/Realtime'),
    },
    {
      path: '/fullscreen',
      name: '监控全屏',
      component: () => import('@/views/fullscreen/fullscreen'),
    },

    {
      path: '/route',
      name: '航线库',
      component: () => import('@/views/route/Route'),
    }, {
      path: '/media',
      name: '媒体库',
      component: () => import('@/views/media/Media'),
    }, {
      path: '/plan',
      name: '计划库',
      component: () => import('@/views/plan'),
    },]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404',
    hidden: true
  }

]

const router = createRouter({
  history: createWebHistory(),
  routes,
  mainPages: routes[1].children
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  console.log(to, from)
  next();
});

// 全局后置守卫
router.afterEach((to, from) => {
  console.log(to, from)
});

export default router
